import useGetEventParticipantListNotJoined from "entity/event/useGetEventParticipantListNotJoined";
import { useNavigate } from "react-router-dom";
import { convertProGradeAsName } from "shared/constant/lookup/proGrade";
import TStyle from "shared/style/tableStyle";
import Pagenation from "widget/Pagenation";
import Search from "widget/Search";
import { useEffect } from "react";

const NotJoinedParticipantList = ({ setTabCount }) => {
  const navigate = useNavigate();
  const [eventParticipantList] = useGetEventParticipantListNotJoined();
  const participantList = eventParticipantList?.data?.participant_list;
  const maxPage = eventParticipantList?.data?.max_page;
  useEffect(() => {
    if (eventParticipantList?.data) {
      setTabCount({
        joined: eventParticipantList?.data?.total_participant ?? "0",
        notJoined: eventParticipantList?.data?.total_not_join ?? "0",
      });
    }
  }, [eventParticipantList?.data]);

  return (
    <>
      <Search placeholder="연락처에 포함되는 글자로 검색" />

      <TStyle.TableDiv style={{ position: "relative" }}>
        <TStyle.TableRow $title>
          {tableHeadList.map((elem, index) => (
            <TStyle.Data $title $size={sizeList[index]}>
              {elem}
            </TStyle.Data>
          ))}
        </TStyle.TableRow>
        {participantList?.map((elem, index) => {
          return (
            <TStyle.TableRow
              $odd={index % 2 === 1}
              onClick={() => navigate(`/user/${elem?.account_idx}/detail`)}
            >
              <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
              <TStyle.Data $size={sizeList[1]}>{elem?.account_idx}</TStyle.Data>
              <TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
              <TStyle.Data $size={sizeList[3]}>{elem?.nickname}</TStyle.Data>
              <TStyle.Data $size={sizeList[4]}>
                +{elem?.international_number}
              </TStyle.Data>
              <TStyle.Data $size={sizeList[5]}>{elem?.contact}</TStyle.Data>
              <TStyle.Data $size={sizeList[6]}>
                {convertProGradeAsName[elem?.pro_grade_flag]}
              </TStyle.Data>
              <TStyle.Data $size={sizeList[7]}>
                {elem?.is_used ? "사용됨" : "미사용"}
              </TStyle.Data>
            </TStyle.TableRow>
          );
        })}
      </TStyle.TableDiv>

      <Pagenation maxPage={maxPage} />
    </>
  );
};

export default NotJoinedParticipantList;

const sizeList = [
  "long", // 참가 IDX
  "long", // 사용자 IDX
  "long", // 이름
  "long", // 닉네임
  "long", // 국가번호
  "longlonglong", // 연락처
  "long", // 프로 자격
  "long", // 사용 여부
];
const tableHeadList = [
  "참가 IDX", // idx
  "사용자 IDX", // account_idx
  "이름", // name
  "닉네임", // nickname
  "국가번호", // international_number
  "연락처", // contact
  "프로 자격", // pro_grade_flag
  "사용 여부", // is_used
];
